<template>
  <div class="!bg-gradient-to-b from-[#2DA7D7] to-[#841FF4] h-full w-full">
    <div class="w-full flex justify-center flex-col items-center mt-6 h-full relative">
      <div class="flex">
        <svg width="58"
             height="46"
             viewBox="0 0 58 46"
             fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path
            d="M22.5625 8.28125L10.1875 46H0.21875L17.125 0.5H23.4688L22.5625 8.28125ZM32.8438 46L20.4375 8.28125L19.4375 0.5H25.8438L42.8438 46H32.8438ZM32.2812 29.0625V36.4062H8.25V29.0625H32.2812ZM57.0312 0.5V46H47.6875V0.5H57.0312Z"
            fill="#FFBE15" />
        </svg>
        <svg width="231"
             height="49"
             viewBox="0 0 231 49"
             fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path
            d="M4.9 47H1.04308e-07V1.5H4.9V47ZM23.7672 47H18.8672V1.5H20.9672L22.7172 6.05C24.9572 2.31666 28.0605 0.449998 32.0272 0.449998C38.8872 0.449998 42.3172 3.71666 42.3172 10.25V47H37.4172V10.25C37.4172 8.47666 37.0205 7.1 36.2272 6.12C35.4805 5.14 34.0805 4.65 32.0272 4.65C29.9739 4.65 28.0839 5.44333 26.3572 7.03C24.6305 8.61667 23.7672 10.1567 23.7672 11.65V47ZM77.9045 38.25C77.9045 44.7833 73.9612 48.05 66.0745 48.05C58.1879 48.05 54.2445 44.7833 54.2445 38.25V32.3H59.1445V38.53C59.1445 40.21 59.7279 41.5167 60.8945 42.45C62.0612 43.3833 63.7879 43.85 66.0745 43.85C68.3612 43.85 70.0879 43.3833 71.2545 42.45C72.4212 41.5167 73.0045 40.2567 73.0045 38.67C73.0045 37.0367 72.8179 35.7533 72.4445 34.82C72.1179 33.84 71.4179 32.8133 70.3445 31.74L58.0245 19.7C56.5779 18.2533 55.5745 16.8533 55.0145 15.5C54.5012 14.1 54.2445 12.35 54.2445 10.25C54.2445 7.12333 55.2012 4.72 57.1145 3.04C59.0745 1.31333 62.0145 0.449998 65.9345 0.449998C73.4479 0.449998 77.2045 3.71666 77.2045 10.25V16.2H72.3045V9.97C72.3045 8.29 71.7445 6.98333 70.6245 6.05C69.5512 5.11666 67.9179 4.65 65.7245 4.65C63.5312 4.65 61.8745 5.11666 60.7545 6.05C59.6812 6.98333 59.1445 8.26667 59.1445 9.9C59.1445 11.5333 59.3079 12.8167 59.6345 13.75C59.9612 14.6833 60.6845 15.6633 61.8045 16.69L74.3345 28.73C75.6879 30.2233 76.6212 31.67 77.1345 33.07C77.6479 34.4233 77.9045 36.15 77.9045 38.25ZM95.4078 47H90.5078V1.5H95.4078V47ZM118.685 28.1V23.9H131.425V38.25C131.425 41.3767 130.468 43.8033 128.555 45.53C126.642 47.21 123.772 48.05 119.945 48.05C116.118 48.05 113.225 47.21 111.265 45.53C109.305 43.8033 108.325 41.3767 108.325 38.25V10.25C108.325 7.12333 109.282 4.72 111.195 3.04C113.108 1.31333 115.978 0.449998 119.805 0.449998C123.632 0.449998 126.525 1.31333 128.485 3.04C130.445 4.72 131.425 7.12333 131.425 10.25V14.1H126.525V10.25C126.525 6.51666 124.308 4.65 119.875 4.65C115.442 4.65 113.225 6.51666 113.225 10.25V38.25C113.225 41.9833 115.442 43.85 119.875 43.85C124.308 43.85 126.525 41.9833 126.525 38.25V28.1H118.685ZM149.275 47H144.375V1.5H149.275V21.8H163.065V1.5H167.965V47H163.065V26H149.275V47ZM180.923 1.5H196.323V5.7H185.823V39.23C185.823 40.5367 186.149 41.6333 186.803 42.52C187.503 43.4067 188.459 43.85 189.673 43.85C190.933 43.85 191.889 43.43 192.543 42.59C193.196 41.7033 193.523 40.5833 193.523 39.23V30.9H198.423V38.95C198.423 41.89 197.629 44.1533 196.043 45.74C194.503 47.28 192.403 48.05 189.743 48.05C187.083 48.05 184.936 47.28 183.303 45.74C181.716 44.1533 180.923 41.89 180.923 38.95V1.5ZM230.483 38.25C230.483 44.7833 226.539 48.05 218.653 48.05C210.766 48.05 206.823 44.7833 206.823 38.25V32.3H211.723V38.53C211.723 40.21 212.306 41.5167 213.473 42.45C214.639 43.3833 216.366 43.85 218.653 43.85C220.939 43.85 222.666 43.3833 223.833 42.45C224.999 41.5167 225.583 40.2567 225.583 38.67C225.583 37.0367 225.396 35.7533 225.023 34.82C224.696 33.84 223.996 32.8133 222.923 31.74L210.603 19.7C209.156 18.2533 208.153 16.8533 207.593 15.5C207.079 14.1 206.823 12.35 206.823 10.25C206.823 7.12333 207.779 4.72 209.693 3.04C211.653 1.31333 214.593 0.449998 218.513 0.449998C226.026 0.449998 229.783 3.71666 229.783 10.25V16.2H224.883V9.97C224.883 8.29 224.323 6.98333 223.203 6.05C222.129 5.11666 220.496 4.65 218.303 4.65C216.109 4.65 214.453 5.11666 213.333 6.05C212.259 6.98333 211.723 8.26667 211.723 9.9C211.723 11.5333 211.886 12.8167 212.213 13.75C212.539 14.6833 213.263 15.6633 214.383 16.69L226.913 28.73C228.266 30.2233 229.199 31.67 229.713 33.07C230.226 34.4233 230.483 36.15 230.483 38.25Z"
            fill="white" />
        </svg>

        <svg
          width="297"
          class="absolute -ml-9 -mt-8 scale-125"
          height="299"
          viewBox="0 0 297 299"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <line
            x1="2.25384"
            y1="211.313"
            x2="86.9864"
            y2="296.045"
            stroke="#EAF4FF"
            stroke-opacity="0.12"
            stroke-width="2.31734"
            stroke-linecap="round" />
          <line
            x1="1.72064"
            y1="263.157"
            x2="34.3274"
            y2="295.764"
            stroke="#EAF4FF"
            stroke-opacity="0.12"
            stroke-width="2.31734"
            stroke-linecap="round" />
          <line
            x1="1.63861"
            y1="159.251"
            x2="138.487"
            y2="296.099"
            stroke="#EAF4FF"
            stroke-opacity="0.12"
            stroke-width="2.31734"
            stroke-linecap="round" />
          <line
            x1="1.63861"
            y1="104.827"
            x2="192.63"
            y2="295.819"
            stroke="#EAF4FF"
            stroke-opacity="0.12"
            stroke-width="2.31734"
            stroke-linecap="round" />
          <line
            x1="1.63861"
            y1="53.1053"
            x2="244.729"
            y2="296.196"
            stroke="#EAF4FF"
            stroke-opacity="0.12"
            stroke-width="2.31734"
            stroke-linecap="round" />
          <line
            x1="1.63861"
            y1="2.05078"
            x2="295"
            y2="295.412"
            stroke="#EAF4FF"
            stroke-opacity="0.12"
            stroke-width="2.31734"
            stroke-linecap="round" />
          <path
            d="M0.0820312 108.913L53.3846 55.6105"
            stroke="#EAF4FF"
            stroke-opacity="0.12"
            stroke-width="2.31734"
            stroke-linecap="round" />
          <path
            d="M0.0820312 162.229L80.4408 81.8706"
            stroke="#EAF4FF"
            stroke-opacity="0.12"
            stroke-width="2.31734"
            stroke-linecap="round" />
          <path
            d="M0.0820312 216.067L107.536 108.613"
            stroke="#EAF4FF"
            stroke-opacity="0.12"
            stroke-width="2.31734"
            stroke-linecap="round" />
          <path
            d="M0.0820312 269.329L134.652 134.759"
            stroke="#EAF4FF"
            stroke-opacity="0.12"
            stroke-width="2.31734"
            stroke-linecap="round" />
          <path d="M24.6172 297.037L161.374 160.279"
                stroke="#EAF4FF"
                stroke-opacity="0.12"
                stroke-width="2.31734"
                stroke-linecap="round" />
          <path d="M78.0117 297.575L188.441 187.146"
                stroke="#EAF4FF"
                stroke-opacity="0.12"
                stroke-width="2.31734"
                stroke-linecap="round" />
          <path d="M131.08 297.284L215.248 213.117"
                stroke="#EAF4FF"
                stroke-opacity="0.12"
                stroke-width="2.31734"
                stroke-linecap="round" />
          <line
            x1="187.723"
            y1="295.951"
            x2="240.988"
            y2="242.686"
            stroke="#EAF4FF"
            stroke-opacity="0.12"
            stroke-width="2.31734"
            stroke-linecap="round" />
          <line
            x1="243.598"
            y1="297.07"
            x2="268.801"
            y2="271.867"
            stroke="#EAF4FF"
            stroke-opacity="0.12"
            stroke-width="2.31734"
            stroke-linecap="round" />
          <circle opacity="0.8"
                  cx="29.4226"
                  cy="187.083"
                  r="2.5129"
                  transform="rotate(90 29.4226 187.083)"
                  fill="white" />
          <circle opacity="0.6"
                  cx="82.4578"
                  cy="187.083"
                  r="2.5129"
                  transform="rotate(90 82.4578 187.083)"
                  fill="white" />
          <circle opacity="0.4"
                  cx="134.753"
                  cy="187.083"
                  r="2.5129"
                  transform="rotate(90 134.753 187.083)"
                  fill="white" />
          <circle opacity="0.8"
                  cx="82.4578"
                  cy="240.002"
                  r="2.5129"
                  transform="rotate(90 82.4578 240.002)"
                  fill="white" />
          <circle opacity="0.6"
                  cx="134.753"
                  cy="240.002"
                  r="2.5129"
                  transform="rotate(90 134.753 240.002)"
                  fill="white" />
          <circle opacity="0.6"
                  cx="134.753"
                  cy="291.987"
                  r="2.5129"
                  transform="rotate(90 134.753 291.987)"
                  fill="white" />
          <circle opacity="0.4"
                  cx="188.442"
                  cy="240.002"
                  r="2.5129"
                  transform="rotate(90 188.442 240.002)"
                  fill="white" />
          <circle opacity="0.4"
                  cx="188.442"
                  cy="294.5"
                  r="2.5129"
                  transform="rotate(90 188.442 294.5)"
                  fill="white" />
          <circle opacity="0.4"
                  cx="82.4578"
                  cy="132.816"
                  r="2.5129"
                  transform="rotate(90 82.4578 132.816)"
                  fill="white" />
          <circle cx="29.4226"
                  cy="240.002"
                  r="2.5129"
                  transform="rotate(90 29.4226 240.002)"
                  fill="white" />
          <circle cx="29.4226"
                  cy="291.987"
                  r="2.5129"
                  transform="rotate(90 29.4226 291.987)"
                  fill="white" />
          <circle opacity="0.6"
                  cx="29.4226"
                  cy="132.816"
                  r="2.5129"
                  transform="rotate(90 29.4226 132.816)"
                  fill="white" />
          <circle opacity="0.4"
                  cx="29.4226"
                  cy="80.2551"
                  r="2.5129"
                  transform="rotate(90 29.4226 80.2551)"
                  fill="white" />
          <circle opacity="0.4"
                  cx="55.1355"
                  cy="107.132"
                  r="2.5129"
                  transform="rotate(90 55.1355 107.132)"
                  fill="white" />
          <circle opacity="0.4"
                  cx="4.9285"
                  cy="106.63"
                  r="2.5129"
                  transform="rotate(90 4.9285 106.63)"
                  fill="white" />
          <circle opacity="0.6"
                  cx="55.1355"
                  cy="160.291"
                  r="2.5129"
                  transform="rotate(90 55.1355 160.291)"
                  fill="white" />
          <circle opacity="0.6"
                  cx="4.9285"
                  cy="159.789"
                  r="2.5129"
                  transform="rotate(90 4.9285 159.789)"
                  fill="white" />
          <circle opacity="0.4"
                  cx="108.214"
                  cy="160.291"
                  r="2.5129"
                  transform="rotate(90 108.214 160.291)"
                  fill="white" />
          <circle opacity="0.6"
                  cx="108.214"
                  cy="214.301"
                  r="2.5129"
                  transform="rotate(90 108.214 214.301)"
                  fill="white" />
          <circle opacity="0.4"
                  cx="161.292"
                  cy="214.301"
                  r="2.5129"
                  transform="rotate(90 161.292 214.301)"
                  fill="white" />
          <circle opacity="0.8"
                  cx="108.214"
                  cy="266.861"
                  r="2.5129"
                  transform="rotate(90 108.214 266.861)"
                  fill="white" />
          <circle opacity="0.6"
                  cx="161.292"
                  cy="266.861"
                  r="2.5129"
                  transform="rotate(90 161.292 266.861)"
                  fill="white" />
          <circle opacity="0.4"
                  cx="216.913"
                  cy="268.253"
                  r="2.5129"
                  transform="rotate(90 216.913 268.253)"
                  fill="white" />
          <circle opacity="0.8"
                  cx="55.1355"
                  cy="214.301"
                  r="2.5129"
                  transform="rotate(90 55.1355 214.301)"
                  fill="white" />
          <circle opacity="0.8"
                  cx="4.9285"
                  cy="213.799"
                  r="2.5129"
                  transform="rotate(90 4.9285 213.799)"
                  fill="white" />
          <circle cx="82.4578"
                  cy="291.987"
                  r="2.5129"
                  transform="rotate(90 82.4578 291.987)"
                  fill="white" />
          <circle cx="4.9285"
                  cy="266.357"
                  r="2.5129"
                  transform="rotate(90 4.9285 266.357)"
                  fill="white" />
        </svg>
      </div>

      <div class="mt-auto bg-white relative bottom-0 mb-2 text-start w-[calc(100%+32px)] rounded-t-lg">
        <div
          :class="{ 'h-[300px]': tab_open == 'activity' }"
          class="px-2 flex cursor-pointer justify-between w-full rounded-t-lg border transition-all ease-in-out border-b-0 h-10 pt-2"
          @click="tab_open == 'activity' ? (tab_open = null) : (tab_open = 'activity')">
          <div class="cursor-pointer flex font-medium">
            <AIActionsActivitySuggestionIcon class="w-5 h-5 mr-2 mt-0.5" /> {{ $t("Activity Suggestion") }}
          </div>
          <ChevronUp :class="{ 'rotate-180': tab_open == 'activity' }" class="w-5 h-5 cursor-pointer transition-all ease-in-out" />
        </div>
        <div
          :class="{ 'h-[300px]': tab_open == 'news_suggestion' }"
          class="px-2 cursor-pointer flex justify-between rounded-t-lg transition-all ease-in-out border border-b-0 h-10 pt-2"
          @click="tab_open == 'news_suggestion' ? (tab_open = null) : (tab_open = 'news_suggestion')">
          <div class="cursor-pointer flex font-medium">
            <AIActionsNewsSuggestionIcon class="w-5 h-5 mr-2 mt-0.5" /> {{ $t("News Suggestion") }}
          </div>

          <ChevronUp :class="{ 'rotate-180': tab_open == 'news_suggestion' }" class="w-5 h-5 cursor-pointer transition-all ease-in-out" />
        </div>
        <div
          :class="{ 'h-[300px]': tab_open == 'fields_suggestion' }"
          class="px-2 cursor-pointer flex justify-between rounded-t-lg transition-all ease-in-out border border-b-0 h-10 pt-2"
          @click="tab_open == 'fields_suggestion' ? (tab_open = null) : (tab_open = 'fields_suggestion')">
          <div class="cursor-pointer flex font-medium">
            <AIActionsFieldsSuggestionIcon class="w-5 h-5 mr-2 mt-0.5" /> {{ $t("Field Suggestion") }}
          </div>

          <ChevronUp :class="{ 'rotate-180': tab_open == 'fields_suggestion' }" class="w-5 h-5 cursor-pointer transition-all ease-in-out" />
        </div>
        <div
          :class="{ 'h-[300px]': tab_open == 'general_suggestion' }"
          class="px-2 cursor-pointer flex justify-between rounded-t-lg transition-all ease-in-out border border-b-0 h-10 pt-2"
          @click="tab_open == 'general_suggestion' ? (tab_open = null) : (tab_open = 'general_suggestion')">
          <div class="cursor-pointer flex font-medium">
            <AIActionsGeneralSuggestionIcon class="w-5 h-5 mr-2 mt-0.5" /> {{ $t("General Suggestion") }}
          </div>

          <ChevronUp
            :class="{ 'rotate-180': tab_open == 'general_suggestion' }"
            class="w-5 h-5 cursor-pointer transition-all ease-in-out" />
        </div>
        <div
          :class="[
            { 'opacity-100  delay-300 transition-opacity': tab_open },
            { 'bottom-[140px]': tab_open == 'activity' },
            { 'bottom-[100px]': tab_open == 'news_suggestion' },
            { 'bottom-[60px]': tab_open == 'fields_suggestion' },
            ,
            { 'bottom-[20px]': tab_open == 'general_suggestion' }
          ]"
          class="absolute text-sm h-[240px] overflow-auto w-[95%] bg-blue-100/20 p-2 rounded-md ml-2 opacity-0 ease-in-out">
          <ol v-if="!insights_ready">
            <!-- Placeholder Skeleton for Insights Loading with Shimmer Effect -->
            <li v-for="i in 3" :key="i" class="mb-4">
              <div class="h-4 rounded w-3/4 mb-2 shimmer" />
              <ul class="ml-4 space-y-1">
                <li v-for="j in 2" :key="j" class="h-3 rounded w-5/6 shimmer" />
              </ul>
            </li>
          </ol>
          <ol v-else-if="tab_open === 'activity'">
            <li v-for="(content, label) in insights?.activity_suggestion" :key="label" class="mb-4">
              <span class="font-semibold">{{ label }}:</span>
              <div v-if="Array.isArray(content)">
                <ul class="ml-4 list-disc">
                  <li v-for="(item, index) in content" :key="index">
                    {{ item }}
                  </li>
                </ul>
              </div>
              <div v-else>
                {{ content }}
              </div>
            </li>
          </ol>

          <ol v-if="tab_open === 'news_suggestion'">
            <li v-for="(content, label) in insights?.news_suggestion" :key="label" class="mb-4">
              <span class="font-semibold">{{ label }}:</span>
              <div v-if="Array.isArray(content)">
                <ul class="ml-4 list-disc">
                  <li v-for="(item, index) in content" :key="index">
                    {{ item }}
                  </li>
                </ul>
              </div>
              <div v-else>
                {{ content }}
              </div>
            </li>
          </ol>

          <ol v-if="tab_open === 'fields_suggestion'">
            <li v-for="(content, label) in insights?.fields_suggestion" :key="label" class="mb-4">
              <span class="font-semibold">{{ label }}:</span>
              <div v-if="Array.isArray(content)">
                <ul class="ml-4 list-disc">
                  <li v-for="(item, index) in content" :key="index">
                    {{ item }}
                  </li>
                </ul>
              </div>
              <div v-else>
                {{ content }}
              </div>
            </li>
          </ol>

          <ol v-if="tab_open === 'general_suggestion'">
            <li v-for="(content, label) in insights?.general_suggestion" :key="label" class="mb-4">
              <span class="font-semibold">{{ label }}:</span>
              <div v-if="Array.isArray(content)">
                <ul class="ml-4 list-disc">
                  <li v-for="(item, index) in content" :key="index">
                    {{ item }}
                  </li>
                </ul>
              </div>
              <div v-else>
                {{ content }}
              </div>
            </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useLayoutItemSharedLogic } from "@/components/shared/pages/useLayoutItemSharedLogic.js"
import { ChevronUp } from "lucide-vue-next"
import AIActionsActivitySuggestionIcon from "@/components/shared/icons/AIActionsActivitySuggestionIcon"
import AIActionsNewsSuggestionIcon from "@/components/shared/icons/AIActionsNewsSuggestionIcon"
import AIActionsFieldsSuggestionIcon from "@/components/shared/icons/AIActionsFieldsSuggestionIcon"
import AIActionsGeneralSuggestionIcon from "@/components/shared/icons/AIActionsGeneralSuggestionIcon"
import dataService from "@/services/data.service"

export default {
  components: {
    ChevronUp,
    AIActionsActivitySuggestionIcon,
    AIActionsNewsSuggestionIcon,
    AIActionsFieldsSuggestionIcon,
    AIActionsGeneralSuggestionIcon
  },
  props: { linkedRecord: null, connectTo: null },
  emits: [],
  data() {
    return {
      tab_open: null,
      insights: null,
      component_record: null,
      record_error: null,
      loading: false,
      insights_ready: false,
      timeout: null
    }
  },

  created() {
    const { loading, record_error, component_record } = useLayoutItemSharedLogic(
      this.$props,
      this.postGetComponentRecord,
      this.registerListeners,
      this.unregisterListeners
    )
    this.loading = loading
    this.record_error = record_error
    this.component_record = component_record
  },

  methods: {
    registerListeners() {
      // pass
    },
    unregisterListeners() {
      clearTimeout(this.timeout)
    },
    postGetComponentRecord() {
      this.getInsights()
    },
    getInsights() {
      this.$store.dispatch("data/getRecord", this.component_record?.id).then((rec_res) => {
        this.component_record = rec_res.data
        dataService.getRecordInsights(rec_res.data.id).then((res) => {
          if (res.data.status == "RECORD_INSIGHTS_GENERATION_INITIATED") {
            this.timeout = setTimeout(() => {
              this.getInsights()
            }, 5000)
          } else {
            this.insights = res.data
            this.insights_ready = true
          }
        })
      })
    }
  }
}
</script>
<style scoped>
/* Custom shimmer animation */
@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

/* Shimmer effect styling */
.shimmer {
  position: relative;
  overflow: hidden;
  background-color: #e0e0e0; /* Base color for skeleton */
}

.shimmer::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.6), transparent);
  animation: shimmer 1.5s infinite;
}
</style>
